import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import Roles from '../enums/Roles.enum';

export const PublicRoute = () => {
  const auth = useAuth();
  return !auth.isAuthenticated() ? <Outlet /> : <Navigate to={auth.getUser().role === Roles.Admin ? '/dashboard' : 'perfil'} />;
};
